import { render } from "./SignaturePadView.vue?vue&type=template&id=7387313e"
import script from "./SignaturePadView.vue?vue&type=script&lang=js"
export * from "./SignaturePadView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__